module.exports = "<script>\n    var position = [0, 1, 1, 1, 1, 1, 1];\n    var tpaginado = [0, 2, 4, 8, 3, 1, 23];\n</script>\n<router-outlet></router-outlet>"